import { hasVisibleMessageText } from '@/utils/messageContent';
import { z } from 'zod';

export const applicationScheme = z.object({
  title: z.string().min(1, { message: 'Обязательное поле' }),
  description: z.string().optional(),
  link: z.url({ message: 'Некорректная ссылка' }).min(1, { message: 'Обязательное поле' }),
  sort: z.number({ message: 'Введите число' }).min(1, { message: 'Обязательное поле' }),
  deviceType: z.string().min(1, { message: 'Обязательное поле' }),
  applicationGroupId: z.string().optional(),
  userGroups: z.array(z.string()).optional(),
  iconLink: z.object({
    url: z.string().optional(),
    rawFile: z.file().nullable(),
  }),
  applicationLinks: z.array(z.string()).optional(),
});

export const applicationGroupScheme = z.object({
  title: z.string().min(1, { message: 'Обязательное поле' }),
  sort: z.number({ message: 'Введите число' }).min(1, { message: 'Обязательное поле' }),
});

export const applicationLinkScheme = z.object({
  title: z.string().min(1, { message: 'Обязательное поле' }),
  link: z.url({ message: 'Некорректная ссылка' }).min(1, { message: 'Обязательное поле' }),
  description: z.string().optional(),
  sort: z.number({ message: 'Введите число' }).min(1, { message: 'Обязательное поле' }),
  applicationId: z.string().min(1, { message: 'Обязательное поле' }),
});

const baseChatScheme = {
  title: z.string().min(1, { message: 'Обязательное поле' }),
  systemName: z.string().min(1, { message: 'Обязательное поле' }),
  sort: z.number({ message: 'Введите число' }).min(1, { message: 'Обязательное поле' }),
  userGroups: z.array(z.string()).optional(),
  chatGroups: z.array(z.string()).optional(),
  avatar: z.object({
    url: z.string().optional(),
    rawFile: z.file().nullable(),
  }),
};

export const chatScheme = z.discriminatedUnion('type', [
  z.object({
    ...baseChatScheme,
    type: z.literal('personal'),
    userId: z.string().trim().min(1, { message: 'Для персонального чата заполните userId' }),
  }),
  z.object({
    ...baseChatScheme,
    type: z.literal('public'),
    userId: z.string().optional(),
  }),
]);

export const chatTemplateScheme = z.object({
  systemName: z.string().min(1, { message: 'Обязательное поле' }),
  title: z.string().min(1, { message: 'Обязательное поле' }),
  sort: z.number({ message: 'Введите число' }).min(0, { message: 'Минимум 0' }),
  avatar: z.object({
    url: z.string().optional(),
    rawFile: z.file().nullable(),
  }),
});

export const chatGroupScheme = z.object({
  systemName: z.string().min(1, { message: 'Обязательное поле' }),
  title: z.string().min(1, { message: 'Обязательное поле' }),
  sort: z.number({ message: 'Введите число' }).min(0, { message: 'Минимум 0' }),
});

export const sendMessageSchema = z
  .object({
    text: z.string().refine((val) => hasVisibleMessageText(val), 'Введите текст сообщения'),
    author: z.string().trim().min(1, 'Введите автора'),
    communityName: z.string().trim().optional(),
    chatSystemName: z.string().trim().min(1, 'Введите имя чата'),
    recipientEmail: z.string().trim().optional(),
    recipientPhone: z.string().trim().optional(),
    recipientEmployeeNumber: z.string().trim().optional(),
    images: z.array(z.instanceof(File)),
  })
  .superRefine((data, ctx) => {
    const recipients = [
      data.recipientEmail,
      data.recipientPhone,
      data.recipientEmployeeNumber,
    ].filter((value) => Boolean(value?.trim()));

    if (recipients.length > 1) {
      const message = 'Можно заполнить только одно поле получателя';
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['recipientEmail'], message });
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['recipientPhone'], message });
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['recipientEmployeeNumber'], message });
    }
  });
